// src/components/SettingsPage.js
import React from 'react';

function SettingsPage() {
  return (
    <div className="p-6">
      <h2 className="text-3xl font-bold text-blue-300 mb-4">Settings</h2>
      <p className="text-gray-400">Manage your profile and application settings here.</p>
    </div>
  );
}

export default SettingsPage;